import React from 'react';
import BigButton from '../../components/BigButton';
import CustomerSearchBox from './CustomerSearchBox';
import CustomerSearchResults from './CustomerSearchResults';

const CustomerSearch = ({searchCriteria, searchResults, clearButtonClickHandler, searchButtonClickHandler}) => 
    <div className="boxWrapper withPadding">
        <CustomerSearchBox searchCriteria={searchCriteria} />
        <div className="text-right button-panel-horizontal">
            <BigButton onClick={clearButtonClickHandler} className="button big gray">Tøm</BigButton>
            <BigButton onClick={searchButtonClickHandler} className="button big green">Søk</BigButton>
        </div>
        <CustomerSearchResults searchResults={searchResults}></CustomerSearchResults>
    </div>

export default CustomerSearch;